<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()" class="generic-form-fields">

    <dx-text-area  [label]="'common.name' | translate | ucfirst" formField required formControlName="name"/>
  
  </form>